/**
 * Toggles the specified attribute on a given field element and updates its
 * data-validate attribute accordingly.
 *
 * @param {HTMLElement} field - The field element to toggle the attribute on.
 * @param {string} attribute - The attribute to toggle.
 * @param {boolean} toggle - Whether to add or remove the attribute.
 * @returns {void}
 * @deprecated for use with legacy validation
 */
export function toggleFieldAttribute(field, attribute, toggle) {
    const validation = field.getAttribute("data-validate").split(" ");

    if (toggle) {
        if (validation.indexOf(attribute) == -1) {
            validation.push(attribute);
        }
    } else {
        const index = validation.indexOf(attribute);
        if (index != -1) {
            validation.splice(index, 1);
        }
    }

    field.setAttribute("data-validate", validation.join(" "));
}
